import { Component, OnInit, ViewChild } from '@angular/core';
import { Shutter } from './model/shutter';
import { ShutterComponent } from './shutter/shutter.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{

  @ViewChild("shutter0") shutter0Component: ShutterComponent;
  @ViewChild("shutter1") shutter1Component: ShutterComponent;
  

  shutterIpas:Shutter;
  shutterOther:Shutter;

  title = 'Shutter Simulator';

  position:number = 0;
  positionSlit:number = 0;

  protected diffTimeCorrection:boolean = true;
  protected curveCorrection:boolean = true;
  protected slitCorrection:boolean = true;  

  shutter0Stopped:boolean = true;
  shutter1Stopped:boolean = true;

  public ngOnInit(){
    this.shutterIpas = new Shutter();

    this.shutterOther = new Shutter();

    this.shutterOther.curveCorrection = false;
    this.shutterOther.slitCorrection = false;
  } 


  changeSelectPosition(position){    
    this.position = +position;

    this.shutter0Component.move(position);
    this.shutter1Component.move(position); 
    
    this.shutter0Stopped = false;
    this.shutter1Stopped = false;

    if (this.position === 100) {
      this.positionSlit = 100;
    } 
    else {
      this.positionSlit = 0;
    }    
  } 

  changeSelectSlitPosition(position) {
    this.positionSlit = +position;
    this.shutter1Component.moveSlits(position);
    if (this.shutterIpas.slitCorrection) {
      this.position = 100;      
      this.shutter1Stopped = false;
    }
  }

  changeCheckboxDiffTime(event, position){
    this.shutterOther.timeDiffCorrection = event.target.checked;
    this.shutterIpas.timeDiffCorrection = event.target.checked;

    this.changeSelectPosition(position);
  } 

  changeCheckboxCurve(event, position){
    this.shutterIpas.curveCorrection = event.target.checked;

    this.changeSelectPosition(position);
  } 

  changeCheckboxSlit(event, position){
    this.shutterIpas.slitCorrection = event.target.checked;

    this.changeSelectPosition(position);
  }
  
  btnSendClick(position) {
    this.changeSelectPosition(position);
  }

  btnSendSlitClick(position) {
    this.changeSelectSlitPosition(position);
  }

  stoppedShutter0(){    
    this.shutter0Stopped = true;
    console.log("Shutter Position: " + this.shutter0Component.position + ". Slits Position: " + this.shutter0Component.positionSlit + ". Slits Correcction: " + this.shutterOther.slitCorrection +".");
    console.log(" Position: " + this.position + ". Slits Position: " + this.positionSlit + ".");
  } 

  stoppedShutter1(){    
    this.shutter1Stopped = true;
    console.log("Shutter Position: " + this.shutter1Component.position + ". Slits Position: " + this.shutter1Component.positionSlit + ". Slits Correcction: " + this.shutterIpas.slitCorrection +".");
    console.log(" Position: " + this.position + ". Slits Position: " + this.positionSlit + ".");    
  } 


}
